export default "__VITE_ASSET__COy7snsH__"